import Events from 'events';
import Dispatcher from "./Dispatcher";
import Constants from "./Constants";
import ProductPriceDetailed from '../components/ProductPriceDetailed';
import { __ } from "../Translator";
import { thronImageUrl } from "../Helpers";


const EventEmitter = Events.EventEmitter;

const STATE = {
  loadingScreenOverlay: {
    isVisible: false,
    text: '',
  },
  customProduct: null,
  productCategory: null,
};

const AppStore = Object.assign({}, EventEmitter.prototype, {
  _showLoadingScreenOverlay: (text = __('Loading…')) => {
    STATE.loadingScreenOverlay = {
      isVisible: true,
      text,
    };

    AppStore.events.showLoadingScreenOverlay.emit(text);
  },

  _hideLoadingScreenOverlay: () => {
    STATE.loadingScreenOverlay = {
      isVisible: false,
      text: '',
    };

    AppStore.events.hideLoadingScreenOverlay.emit();
  },

  _openDropdown(uniqueId) {
    AppStore.events.openDropdown.emit(uniqueId);
  },

  _closeDropdown(uniqueId) {
    AppStore.events.closeDropdown.emit(uniqueId);
  },

  _initCustomProduct: (product, customProduct = null) => {
    // @todo 2017-09-28 Refactor somehow, I don't like this if-else
    if (customProduct) {
      STATE.customProduct = {
        country_id: customProduct.country_id,
        hash: customProduct.hash,
        preset: customProduct.preset,
        perforated: !! customProduct.perforated,
        custom_colored: true,
        custom_fitted: !! customProduct.custom_fitted,
        color: product.default_color,
        size: customProduct.size,
        sizeType: customProduct.sizeType,
        locked: customProduct.locked,
        screenshots: customProduct.screenshots,
        product,
        simpleSpecification: customProduct.specification,
        files: customProduct.files,
        texts: customProduct.texts,
      };
    } else {
      STATE.customProduct = {
        country_id: null,
        hash: null,
        preset: product.default_color_preset,
        perforated: null,
        custom_colored: null,
        custom_fitted: null,
        color: product.default_color,
        size: null,
        sizeType: null,
        locked: false,
        screenshots: {
          front: thronImageUrl(product.default_color.preview_image_url, ProductPriceDetailed.ProductImageWidth, ProductPriceDetailed.ProductImageHeight),
          back: null,
          left: null,
          right: null,
        },
        product,
        simpleSpecification: [],
        files: [],
        texts: [],
      }
    }

    AppStore.events.initCustomProduct.emit(product);
  },

  _updateCustomProduct: partialCustomProduct => {
    STATE.customProduct = Object.assign(
      STATE.customProduct, partialCustomProduct
    );

    AppStore.events.updateCustomProduct.emit(partialCustomProduct);
  },

  _setProductCategory: category => {
    STATE.productCategory = category;

    AppStore.events.setProductCategory.emit(category);
  },

  getLoadingScreenOverlayState() {
    return STATE.loadingScreenOverlay;
  },

  getCustomProduct() {
    return STATE.customProduct;
  },

  // @todo 2020-03-06 faracosì#
  setCustomProductSimpleSpecification(simpleSpecification) {
    return STATE.customProduct.simpleSpecification = simpleSpecification;
  },

  getProductCategory() {
    return STATE.productCategory;
  },

  events: {
    showLoadingScreenOverlay: {
      emit(text, errors) {
        AppStore.emit(Constants.APP_SHOW_LOADING_SCREEN_OVERLAY, text, errors);
      },
      addListener(callback) {
        AppStore.on(Constants.APP_SHOW_LOADING_SCREEN_OVERLAY, callback);
      },
      removeListener(callback) {
        AppStore.removeListener(Constants.APP_SHOW_LOADING_SCREEN_OVERLAY, callback);
      }
    },

    hideLoadingScreenOverlay: {
      emit(errors) {
        AppStore.emit(Constants.APP_HIDE_LOADING_SCREEN_OVERLAY, errors);
      },
      addListener(callback) {
        AppStore.on(Constants.APP_HIDE_LOADING_SCREEN_OVERLAY, callback);
      },
      removeListener(callback) {
        AppStore.removeListener(Constants.APP_HIDE_LOADING_SCREEN_OVERLAY, callback);
      }
    },

    openDropdown: {
      emit(uniqueId, errors) {
        AppStore.emit(Constants.OPEN_DROPDOWN, uniqueId, errors);
      },
      addListener(callback) {
        AppStore.on(Constants.OPEN_DROPDOWN, callback);
      },
      removeListener(callback) {
        AppStore.removeListener(Constants.OPEN_DROPDOWN, callback);
      }
    },

    closeDropdown: {
      emit(uniqueId, errors) {
        AppStore.emit(Constants.CLOSE_DROPDOWN, uniqueId, errors);
      },
      addListener(callback) {
        AppStore.on(Constants.CLOSE_DROPDOWN, callback);
      },
      removeListener(callback) {
        AppStore.removeListener(Constants.CLOSE_DROPDOWN, callback);
      }
    },

    initCustomProduct: {
      emit(customProduct, errors) {
        AppStore.emit(Constants.APP_INIT_CUSTOM_PRODUCT, customProduct, errors);
      },
      addListener(callback) {
        AppStore.on(Constants.APP_INIT_CUSTOM_PRODUCT, callback);
      },
      removeListener(callback) {
        AppStore.removeListener(Constants.APP_INIT_CUSTOM_PRODUCT, callback);
      }
    },

    updateCustomProduct: {
      emit(partialCustomProduct, errors) {
        AppStore.emit(Constants.APP_UPDATE_CUSTOM_PRODUCT, partialCustomProduct, errors);
      },
      addListener(callback) {
        AppStore.on(Constants.APP_UPDATE_CUSTOM_PRODUCT, callback);
      },
      removeListener(callback) {
        AppStore.removeListener(Constants.APP_UPDATE_CUSTOM_PRODUCT, callback);
      }
    },

    setProductCategory: {
      emit(category, errors) {
        AppStore.emit(Constants.APP_SET_PRODUCT_CATEGORY, category, errors);
      },
      addListener(callback) {
        AppStore.on(Constants.APP_SET_PRODUCT_CATEGORY, callback);
      },
      removeListener(callback) {
        AppStore.removeListener(Constants.APP_SET_PRODUCT_CATEGORY, callback);
      }
    },
  },

});

Dispatcher.register(action => {
  switch (action.actionType) {
    case Constants.APP_SHOW_LOADING_SCREEN_OVERLAY:
      return AppStore._showLoadingScreenOverlay(action.text);

    case Constants.APP_HIDE_LOADING_SCREEN_OVERLAY:
      return AppStore._hideLoadingScreenOverlay();

    case Constants.OPEN_DROPDOWN:
      return AppStore._openDropdown(action.uniqueId);

    case Constants.CLOSE_DROPDOWN:
      return AppStore._closeDropdown(action.uniqueId);

    case Constants.APP_INIT_CUSTOM_PRODUCT:
      return AppStore._initCustomProduct(action.product, action.customProduct);

    case Constants.APP_UPDATE_CUSTOM_PRODUCT:
      return AppStore._updateCustomProduct(action.partialCustomProduct);

    case Constants.APP_SET_PRODUCT_CATEGORY:
      return AppStore._setProductCategory(action.category);

    default:
      // console.warn('Invalid action', action);
  }
});

export default AppStore;



// WEBPACK FOOTER //
// ./src/flux/AppStore.js